import React from 'react';

import SettingsNotificationsForm from '../forms/SettingsNotificationsForm';
import ProSettingsNotificationsForm from '../forms/ProSettingsNotificationsForm';
import NotificationSettingStore from '../stores/NotificationSettingStore';

import LoadingView from '../components/LoadingView';

import connectToStores from 'alt/utils/connectToStores'

@connectToStores
class SettingsNotifications extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            settingsSaved: false,
            isLoading: false
        }

        NotificationSettingStore.getSettings()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.notificationSettingStore.settingsSaved !== this.state.settingsSaved) {
            //Setting timeout to give spinner a chance to show properly
            setTimeout(x => {this.setState({settingsSaved: nextProps.notificationSettingStore.settingsSaved, isLoading: false})}, 250);
        }
    }

    static getPropsFromStores() {
        return {
            notificationSettingStore: NotificationSettingStore.getState()
        };
    }

    static getStores() {
        return [NotificationSettingStore];
    }

    saveNotificationSettings() {
        const data = this.refs.notificationForm.getValue();
        if (data) {
            this.setState({isLoading: true});
            NotificationSettingStore.updateSettings(data);
        }
    }

    getSaveButton(company) {
        let button = <button onClick={this.saveNotificationSettings.bind(this)} className="btn btn-small btn-green">Save settings</button>;
        if (this.state.isLoading) {
            button = <button onClick={this.saveNotificationSettings.bind(this)} className="btn btn-small btn-green"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></button>;
        }
        return button;
    }

    render () {
        const user = this.props.user;
        const settings = this.props.notificationSettingStore.settings || {};
        const settingsSaved = this.state.settingsSaved;

        if (!this.props.notificationSettingStore.loadedSettings || (user.profile.profile.role === 'pro' && !user.profile.profile.is_candidate)) {
            return (
                <div className={"settings-notifications" + (this.props.isActive ? " active" : "")}>
                    <LoadingView />
                </div>
            );
        }

        const form = user.profile.profile.role === 'bsn' ? <SettingsNotificationsForm ref="notificationForm" initialFormData={settings} /> : <ProSettingsNotificationsForm ref="notificationForm" initialFormData={settings} />;

        return (
            <div className={"settings-notifications" + (this.props.isActive ? " active" : "")}>
                {form}
                <div className="tab-section">
                    {this.getSaveButton()}
                    <p className={"data-info " + (settingsSaved ? "saved" : "")}>Settings saved!</p>
                </div>
            </div>
        );
    }
}

export default SettingsNotifications;



/** WEBPACK FOOTER **
 ** ./app/src/components/SettingsNotifications.js
 **/